export const DELETE_ENTITY = "DELETE_ENTITY";
export const DELETE_ENTITY_SUCCESS = "DELETE_ENTITY_SUCCESS";
export const DELETE_ENTITY_ERROR = "DELETE_ENTITY_ERROR";
export const DELETE_ENTITY_CLEAR_DATA = "DELETE_ENTITY_CLEAR_DATA";

